module.exports = __webpack_public_path__ + "img/13.5e7c97b8.jpg";